import gql from "graphql-tag";

export const getProject = gql`
  query GetProject($input: GetProjectInput!) {
    project(input: $input) {
      project {
        id
        name
        team {
            role
            user {
                    id
                    name
                    email
                    profilePictureUrl
            }
        }
        collections {
            id
            name
            index
            searchableFields {
                field
                model
            }
            activity {
              status
              message
              timestamp
              jobId
            }
            archived
            syncing
            syncedAt
            encoding
            encodedAt
            changed
            changedAt
        }
        billing {
          hasDefaultPayment
          status
          plan
        }
        models {
            id
            name
            status
            trialEnds
            cpu
            ram
            region
            signatures
            activity {
              status
              message
              timestamp
              jobId
            }
        }
        active
        archived
        createdAt
        updatedAt
        invites {
            author {
              id
              name
              profilePictureUrl
            }
            invitedAt
            role
            status
            code
            email
        }
      }
    }
  }
`;

export const getProjectOptions = {
  name: "getProject",
};
